import React from 'react';

const RoleList = ({ roles, selectedRole, onSelect, onEdit }) => (
  <ul className="space-y-2">
    {roles.map((role) => (
      <li key={role.id}>
        <div
          className={`w-full flex justify-between items-center p-2 rounded-lg text-left transition-colors cursor-pointer ${
            selectedRole && selectedRole.id === role.id
              ? 'bg-primary-100 dark:bg-primary-900/30 text-primary-700 dark:text-primary-300'
              : 'text-gray-700 dark:text-gray-300 hover:bg-gray-100 dark:hover:bg-gray-700'
          }`}
          onClick={() => onSelect(role)}
          tabIndex={0}
          role="button"
          onKeyDown={e => {
            if (e.key === 'Enter' || e.key === ' ') {
              e.preventDefault();
              onSelect(role);
            }
          }}
        >
          <span>{role.name}</span>
          <button
            className="ml-2 text-xs text-primary-600 dark:text-primary-400 hover:underline"
            onClick={e => { e.stopPropagation(); onEdit(role); }}
            type="button"
          >
            Modifier
          </button>
        </div>
      </li>
    ))}
  </ul>
);

export default RoleList;
